import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';

const TestCertificatePage: React.FC = () => {
  const { attemptId } = useParams<{ attemptId: string }>();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        p: 3,
      }}
    >
      <Paper
        elevation={10}
        sx={{
          p: 4,
          maxWidth: 600,
          width: '100%',
          borderRadius: 3,
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" sx={{ mb: 2, color: 'primary.main' }}>
          Certificate Page Test
        </Typography>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Route is working! ✅
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Attempt ID: {attemptId || 'No ID provided'}
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          URL: /certificate/{attemptId}
        </Typography>
      </Paper>
    </Box>
  );
};

export default TestCertificatePage;